(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssbc-native-catalog"] && !Shopify.designMode) return;
  try {
    function ssbcSetCatalogDisclosure() {
    const mobile = window.matchMedia('(max-width: 768px)');
    document.querySelectorAll('.ssbc-catalog-sidebar').forEach((panel) => {
      panel.open = !mobile.matches;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ssbcSetCatalogDisclosure, { once: true });
  } else {
    ssbcSetCatalogDisclosure();
  }
  window.matchMedia('(max-width: 768px)').addEventListener('change', ssbcSetCatalogDisclosure);
  } catch(e) { console.error(e); }
})();

})();
